import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function SyncIcon(props: SimpleIconInterface): JSX.Element {
  const { stroke = IconColors.White, ...rest } = props;

  return (
    <SimpleIcon height="10" stroke={stroke} viewBoxDimensions="0 0 14 10" width="14" {...rest}>
      <path
        d="M8.00083 0.998535L10 3.0002H4"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="M10 7H4L5.99917 9.00083"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </SimpleIcon>
  );
}
